import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { STARTER, FREE } from 'self-service-api/constants/ProductLevels';
import { OLAF } from 'HubStyleTokens/colors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import FeatureTableFreePriceDisplay from './FeatureTableFreePriceDisplay';
import { SUITE_FEATURE_TABLE_HEADER } from '../../constants/tracking/Locations';
import SuiteFeatureTableBadge from '../common/SuiteFeatureTableBadge';
import { CrmSuitePrice } from '../merch-card/price-display/CrmSuitePrice';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';
import SuiteTileCTAsContainer from '../merch-card/SuiteTileCTAsContainer';
import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
const TableHeaderCell = styled.th.withConfig({
  displayName: "SuiteFeatureTableHeaderCell__TableHeaderCell",
  componentId: "n6p3zt-0"
})(["text-align:center;font-weight:normal;position:relative;background-color:", ";box-shadow:", ";width:", ";padding:16px 0;"], ({
  isHighlightedCell
}) => isHighlightedCell && `${OLAF}`, ({
  isHighlightedCell
}) => isHighlightedCell && 'inset 0px 4px 4px rgba(124, 152, 182, 0.2)', ({
  columns
}) => columns < 3 ? `calc(50%/${columns})` : `calc(70%/${columns})`);
const badgeStyle = {
  top: '16px',
  left: 0,
  right: 0,
  margin: '0 auto',
  width: 'fit-content'
};
const ctaStyles = {
  width: '154px',
  padding: '11px'
};

const SuiteFeatureTableHeaderCell = ({
  productLevel,
  columns,
  isSuiteStarterPage,
  isLearnMoreModal
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isFree = productLevel === FREE;
  const contentProps = {
    productLevel,
    concise: true
  };
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel
  }));
  let isHighlightedCell = STARTER === productLevel;

  if (!isSuiteStarterPage && !isLearnMoreModal) {
    isHighlightedCell = isCurrentPlanLevel;
  }

  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    isHighlightedCell: isHighlightedCell,
    columns: columns,
    children: [isHighlightedCell && /*#__PURE__*/_jsx(SuiteFeatureTableBadge, {
      use: isSuiteStarterPage || isLearnMoreModal ? 'new' : 'koala',
      translationKey: isSuiteStarterPage || isLearnMoreModal ? 'recommended' : 'currentPlan',
      badgeStyle: badgeStyle
    }), /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `products.crm.${productLevel}`
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-y-1",
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [19],
        widths: [190],
        className: "flex-column m-y-2",
        Content: isFree ? FeatureTableFreePriceDisplay : CrmSuitePrice,
        contentProps: isFree ? {} : contentProps
      })
    }), isFree ? /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
      authedComponentLoader: () => import(
      /* webpackChunkName: "authed-chunk" */
      `pricing-pages-ui/components/suite-starter-page/CurrentPlanButton`),
      publicComponentLoader: () => import(
      /* webpackChunkName: "public-chunk" */
      `pricing-pages-ui/components/common/SignupButton`),
      authedComponentProps: {
        ctaStyles: Object.assign({}, ctaStyles, {
          visibility: `${isCurrentPlanLevel ? 'visible' : 'hidden'}`
        })
      },
      publicComponentProps: {
        style: ctaStyles,
        sourceId: SUITE_FEATURE_TABLE_HEADER,
        productLine: 'crm',
        use: 'primary'
      }
    }) : /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      heights: [40],
      children: /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
        productLevel: productLevel,
        trackingSource: SUITE_FEATURE_TABLE_HEADER,
        ctaStyles: ctaStyles,
        returnFirstCTAOnly: true
      })
    })]
  });
};

export default SuiteFeatureTableHeaderCell;